export const addressToString = (address: UserAddress) =>
  Object.values(address)
    .filter(value => !!value)
    .join(', ');
